import React from 'react';
import { pagesData, companyInfo } from '../data/mock';
import { motion } from 'framer-motion';
import { Briefcase, Mail, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const CareersPage = () => {
  const { careers } = pagesData;

  return (
    <div className="min-h-screen bg-[#050505] pt-20">
      <div className="orange-orb orange-orb-1 top-32 -left-32 w-[28rem] h-[28rem] z-0" />
      <div className="orange-orb orange-orb-2 top-1/2 -right-32 w-[32rem] h-[32rem] z-0" />
      <div className="relative z-10">
      <SEO
        title="Careers"
        description="Join the Agentic Atoms team. We're innovators building cutting-edge AI solutions. Explore career opportunities in AI consulting and development."
        path="/careers"
      />
      {/* Back button */}
      <div className="max-w-4xl mx-auto px-6 pt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </div>

      <div className="max-w-4xl mx-auto px-6 pb-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring' }}
            className="w-20 h-20 bg-white/[0.05] rounded-3xl flex items-center justify-center mx-auto mb-6"
          >
            <Briefcase className="w-10 h-10 text-white" />
          </motion.div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {careers.title}
          </h1>
          <p className="text-[#A1A1AA] text-lg">
            {careers.subtitle}
          </p>
        </motion.div>

        {/* No Openings Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-white/[0.03] rounded-3xl p-10 md:p-14 text-center"
        >
          <div className="w-16 h-16 bg-[#050505] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm">
            <Briefcase className="w-8 h-8 text-[#71717A]" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">
            No Open Positions
          </h2>
          <p className="text-[#A1A1AA] max-w-lg mx-auto mb-8 leading-relaxed">
            {careers.noOpeningsMessage}
          </p>
          
          {/* Contact Note */}
          <div className="bg-[#050505] rounded-2xl p-6 max-w-md mx-auto">
            <div className="flex items-center justify-center gap-3 text-white">
              <Mail className="w-5 h-5" />
              <span className="font-medium">Stay Connected</span>
            </div>
            <p className="text-sm text-[#A1A1AA] mt-2">
              {careers.contactNote}
            </p>
            <a
              href={`mailto:${companyInfo.email}`}
              className="inline-flex items-center gap-2 mt-4 px-6 py-3 bg-white text-black rounded-full text-sm font-medium hover:bg-[#1a1a1a] transition-colors"
            >
              <Mail className="w-4 h-4" />
              Send Resume
            </a>
          </div>
        </motion.div>

        {/* Company Culture Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-16"
        >
          <h3 className="text-2xl font-bold text-white mb-6 text-center">
            Why Work With Us?
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: 'Innovation First', desc: 'Work on cutting-edge AI projects that shape the future of business.' },
              { title: 'Remote Friendly', desc: 'Work from anywhere. We believe in flexibility and trust.' },
              { title: 'Growth Focused', desc: 'Continuous learning opportunities and career development.' }
            ].map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 + index * 0.1 }}
                className="p-6 bg-[#050505] border border-white/[0.08] rounded-2xl hover:border-white/10 transition-colors"
              >
                <h4 className="font-semibold text-white mb-2">{item.title}</h4>
                <p className="text-sm text-[#A1A1AA]">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div></div>
    </div>
  );
};

export default CareersPage;
